import React from 'react';
import {
  FDIcon, FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dataAttrs } from 'Helpers/Testing';
import Button1 from 'Components/ComponentLibrary/Components/Buttons/Button1';


function MiscItem({ onDelete, onBlur }) {
  const theme = useTheme();
  const { resource } = useMetaLayoutContext();

  return (
    <Paper
      style={{
        borderRadius: '16px',
        backgroundColor: `${theme.palette.facet.accentBlue20}`,
      }}
      {...dataAttrs('onboarding-custom-expense')}
    >
      <FDStack direction={'row'} alignItems={'center'}>
        <MetaControlField attr={'title'} onInlineSubmit={() => onBlur(resource)} />
        <Button1
          onClick={() => onDelete(resource)}
          color={'primary'}
          size={'small'}
          variant={'icon'}
          round
          {...dataAttrs('custom-expense-delete-button')}
        >
          <FDIcon icon={'close'} color={'error'} size={'sm'} />
        </Button1>
      </FDStack>
    </Paper>
  );
}

MiscItem.propTypes = {
  onDelete: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
};

MiscItem.defaultProps = {
};

export default MiscItem;
